import React, { memo } from 'react';

import { BannerLayout, BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { ExpandableMessage } from 'ui-components/components/expandable-message';

import { useRateViewerContext } from '../rate-viewer-context-provider';

export const AllRatesViewErrorBanner = memo(() => {
  const { allRatesErrorMessage, dismissErrorMessage, onToggleErrorMessageExpander } = useRateViewerContext();

  return (
    <BannerMessageV2
      content={<ExpandableMessage maxLines={1} messages={allRatesErrorMessage} onToggleExpander={onToggleErrorMessageExpander} />}
      layout={BannerLayout.Full}
      onClose={dismissErrorMessage}
      status={BannerStatus.Info}
    />
  );
});
